import { Line } from 'react-chartjs-2';

const mttMetrics = {
  labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
  datasets: [
    {
      label: 'MTTD (minutes)',
      data: [45, 42, 38, 35, 32, 30],
      borderColor: 'rgb(79, 70, 229)',
      tension: 0.4,
    },
    {
      label: 'MTTR (minutes)',
      data: [120, 115, 105, 98, 92, 85],
      borderColor: 'rgb(234, 179, 8)',
      tension: 0.4,
    },
  ],
};

const securityTools = [
  { name: 'EDR', status: 'operational', coverage: 98 },
  { name: 'SIEM', status: 'operational', coverage: 95 },
  { name: 'NDR', status: 'degraded', coverage: 85 },
  { name: 'WAF', status: 'operational', coverage: 100 },
];

export default function TechnicalReadiness() {
  return (
    <div className="space-y-6 mt-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-medium mb-4">Security Tools Status</h3>
          <div className="space-y-4">
            {securityTools.map((tool) => (
              <div key={tool.name} className="flex items-center justify-between">
                <div>
                  <h4 className="font-medium">{tool.name}</h4>
                  <span
                    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                      tool.status === 'operational'
                        ? 'bg-green-100 text-green-800'
                        : 'bg-yellow-100 text-yellow-800'
                    }`}
                  >
                    {tool.status}
                  </span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-32 bg-gray-200 rounded-full h-2">
                    <div
                      className="bg-indigo-600 h-2 rounded-full"
                      style={{ width: `${tool.coverage}%` }}
                    />
                  </div>
                  <span className="text-sm font-medium">{tool.coverage}%</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-medium mb-4">MTTD/MTTR Metrics</h3>
          <div className="h-64">
            <Line data={mttMetrics} />
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-medium mb-4">Backup System Health</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="border rounded-lg p-4">
            <h4 className="font-medium text-gray-900">Last Backup</h4>
            <div className="mt-2">
              <p className="text-sm font-medium text-green-600">Successful</p>
              <p className="text-sm text-gray-500">2 hours ago</p>
            </div>
            <div className="mt-2">
              <span className="text-xs text-gray-500">Size: 2.5TB</span>
            </div>
          </div>
          <div className="border rounded-lg p-4">
            <h4 className="font-medium text-gray-900">Recovery Testing</h4>
            <div className="mt-2">
              <p className="text-sm font-medium text-green-600">Verified</p>
              <p className="text-sm text-gray-500">Last test: 5 days ago</p>
            </div>
            <div className="mt-2">
              <span className="text-xs text-gray-500">RTO: 4 hours</span>
            </div>
          </div>
          <div className="border rounded-lg p-4">
            <h4 className="font-medium text-gray-900">Storage Status</h4>
            <div className="mt-2">
              <div className="flex items-center space-x-2">
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div
                    className="bg-green-500 h-2 rounded-full"
                    style={{ width: '65%' }}
                  />
                </div>
                <span className="text-sm font-medium">65%</span>
              </div>
              <p className="text-sm text-gray-500 mt-1">3.2TB free of 10TB</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}